import { msg } from "@lingui/core/macro";
import { useLingui } from "@lingui/react";
import { TrendingDown, TrendingUp } from "lucide-react";

import { useAssetLookup } from "../api/useAssetLookup";
import { formatGameTime } from "../format/formatGameTime";
import { formatList } from "../format/formatList";
import { FindingCard } from "./FindingCard";
import type { FindingProps } from "./FindingProps";
import { iconSize } from "./iconSize";
import { IconBadge } from "./IconBadge";

const TITLE = msg({
  id: "finding.lane_result",
  message: "{outcome, select, won {Lane won} other {Lane lost}}",
});

const DETAILS = msg({
  id: "finding.lane_result.details",
  message:
    "By {time} you had {souls, plural, one {# soul} other {# souls}}, your lane opponents ({enemies}) {laneSouls, plural, one {# soul} other {# souls}} on average.",
});

const SUMMARY = msg({
  id: "finding.lane_result.summary",
  message: "{diff} souls vs lane opponents by {time}",
});

// Итог линии: души против соперников по линии в конце фазы линий.
export const LaneResult = ({ finding, variant }: FindingProps<"lane_result">) => {
  const { i18n } = useLingui();
  const findHero = useAssetLookup("heroes");
  const { souls, lane_souls: laneSouls, time_s: timeS } = finding.params;
  const diff = new Intl.NumberFormat(i18n.locale, { signDisplay: "always" }).format(
    souls - laneSouls,
  );
  const time = formatGameTime(timeS);
  const enemies = formatList(
    finding.params.lane_enemy_hero_ids.map((id) => findHero(id).name),
    i18n.locale,
  );
  return (
    <FindingCard
      code={finding.code}
      severity={finding.severity}
      variant={variant}
      icon={
        <IconBadge
          icon={finding.severity === "good" ? TrendingUp : TrendingDown}
          size={iconSize(variant)}
        />
      }
      title={i18n._({
        ...TITLE,
        values: { outcome: finding.severity === "good" ? "won" : "lost" },
      })}
      details={i18n._({ ...DETAILS, values: { time, souls, laneSouls, enemies } })}
      summary={i18n._({ ...SUMMARY, values: { diff, time } })}
    />
  );
};
